@if (showSpinner) {
    <div class="progress-overlay" tabindex="-1">
        <div class="progress-overlay-content">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
}
